import NavMenu from './navMenu';
export default NavMenu;